// utils/messengerConstants.js
// ─────────────────────────────────────────────────────────
// Shared constants สำหรับ Messenger module
// ─────────────────────────────────────────────────────────

// ── Workflow Status ──────────────────────────────────────
export const WF = {
    CREATE:       1,
    USER_CANCEL:  2,
    ADMIN_RETURN: 3,
    ADMIN_CANCEL: 4,
    ASSIGN:       5,
    DOING:        6,
    COMPLETE:     7,
    INCOMPLETE:   8,
    REASSIGN:     9,
    CLOSE_OK:     10,
    CLOSE_COND:   11,
};

// ── Tab Config ───────────────────────────────────────────
export const TABS = [
    { key: 'today',   label: 'งานวันนี้'       },
    { key: 'pending', label: 'งานค้าง'         },
    { key: 'done',    label: 'งานที่เสร็จแล้ว' },
];